import type {ConversationState} from './reducer.ts'

export interface OpeningContact {role?:string;isDecisionMaker?:boolean|null}
/** Contact context chooses an opening only; it never establishes purchasing approval. */
export function contactOpeningRole(contact:OpeningContact):boolean|null {
  if(contact.isDecisionMaker===true)return true
  const role=contact.role?.trim()??''
  if(/\b(gatekeeper|receptionist|reception|front desk|switchboard)\b/i.test(role))return false
  if(contact.isDecisionMaker!==false&&/^(owner|co-owner|founder|co-founder|ceo|president|decision maker)$/i.test(role))return true
  return null
}
export function seedContactOpening(state:ConversationState,contact:OpeningContact):ConversationState {
  if(!state.v9||state.events.length||state.v9.frames.length||state.v9.main!=='S01')return state
  const roleKnown=contactOpeningRole(contact)
  return {...state,v9:{...state.v9,step:roleKnown===true?'awareness':'role',facts:{...state.v9.facts,roleKnown}}}
}
